import { Route } from '@angular/router';

export const dashboardRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'statistics-payments',
    pathMatch: 'full',
  },
  {
    path: 'statistics-payments',
    loadComponent: () => import('./pages').then(p => p.DashboardPaymentsPageComponent),
    title: 'UIMS - Statistics Payments',
  },
  {
    path: 'statistics-refill',
    loadComponent: () => import('./pages').then(p => p.DashboardRefillPageComponent),
    title: 'UIMS - Statistics Refill',
  },
  {
    path: 'statistics-benefits',
    loadComponent: () => import('./pages').then(p => p.DashboardBenefitsComponent),
    title: 'UIMS - Statistics Benefits',
  },
  {
    path: 'statistics-abonements',
    loadComponent: () => import('./pages').then(p => p.DashboardAbonementsComponent),
    title: 'UIMS - Statistics Abonements',
  },
  {
    path: 'statistics-account-status',
    loadComponent: () => import('./pages').then(p => p.DashboardAccountStatusComponent),
    title: 'UIMS - Statistics Account Status',
  },
  {
    path: 'statistics-users',
    loadComponent: () => import('./pages').then(p => p.DashboardUsersComponent),
    title: 'UIMS - Statistics Users',
  },
  {
    path: 'statistics-fixations',
    loadComponent: () => import('./pages').then(p => p.DashboardFixationsComponent),
    title: 'UIMS - Statistics Fixations',
  },
  {
    path: 'statistics-session-duration',
    loadComponent: () => import('./pages').then(p => p.DashboardDurationComponent),
    title: 'UIMS - Statistics Session Duration',
  },
  {
    path: 'statistics-zone-occupancy',
    loadComponent: () => import('./pages').then(p => p.DashboardOccupancyComponent),
    title: 'UIMS - Statistics Zones Occupancy',
  },
  {
    path: 'statistics-violations',
    loadComponent: () => import('./pages').then(p => p.DashboardViolationsComponent),
    title: 'UIMS - Statistics Violations',
  },
  {
    path: 'statistics-parkings',
    loadComponent: () => import('./pages').then(p => p.DashboardParkingsComponent),
    title: 'UIMS - Statistics Parkings',
  },
];
